import React from 'react';
import { Link } from 'react-router-dom';
import './AuthSlimFooter.css';

/**
 * AuthSlimFooter — minimal footer for /login and /signup only.
 * The full MarketingFooter is a navigation surface; on auth pages it's a
 * distraction (PostHog: zero footer clicks there, 14d) and industry standard
 * is a stripped page. Legal links stay reachable — these are the pages where
 * people enter credentials. All other marketing pages keep the full footer.
 */
const AuthSlimFooter = () => (
  <footer className="auth-slim-footer">
    <span>© {new Date().getFullYear()} CellCog</span>
    <Link to="/support/privacy-policy">Privacy</Link>
    <Link to="/support/terms-of-service">Terms</Link>
  </footer>
);

export default AuthSlimFooter;
